import PropTypes from "prop-types";
import React from "react";
import { Badge, Breadcrumbs, PageHeader } from "@opendate-app/setlist";
import "../styles/eventHeader.css";

const STATUS_BADGES = {
  past: { label: "Past", color: "gray" },
  canceled: { label: "Canceled", color: "error" },
  postponed: { label: "Postponed", color: "gray-blue" },
  on_sale: { label: "On sale", color: "success" },
  pre_sale: { label: "Pre-sale", color: "orange" },
  announced: { label: "Announced", color: "blue" },
  hold: { label: "Hold", color: "warning" },
};
const CONFIRMED_BADGE = { label: "Confirmed", color: "brand" };

export const EventStatusBadge = ({ classification }) => {
  const status = STATUS_BADGES[classification] || CONFIRMED_BADGE;
  return <Badge color={status.color} size="md" dot>{status.label}</Badge>;
};

EventStatusBadge.propTypes = {
  classification: PropTypes.string,
};

export const EventHeaderField = ({ icon: Icon, label, children }) => (
  <div className="event-page-header__field">
    <span className="event-page-header__field-label">
      {Icon ? <Icon width={16} height={16} aria-hidden="true" /> : null}
      {label}
    </span>
    {children}
  </div>
);

EventHeaderField.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.node.isRequired,
  children: PropTypes.node,
};

const EventHeader = ({ title, rootCrumb, badges, meta, actions, edited, children }) => (
  <header className="event-page-header">
    <PageHeader
      className="event-page-header__page-header"
      divider={false}
      breadcrumbs={<Breadcrumbs items={[rootCrumb, { label: title }]} />}
      title={
        <span className="event-page-header__title">
          {title}
          {badges}
        </span>
      }
      meta={meta}
      actions={actions}
    />
    <div className="event-page-header__toolbar">
      <div className="event-page-header__toolbar-fields">{children}</div>
      {edited ? <div className="event-page-header__edited">{edited}</div> : null}
    </div>
  </header>
);

EventHeader.propTypes = {
  title: PropTypes.string.isRequired,
  rootCrumb: PropTypes.shape({ label: PropTypes.node, href: PropTypes.string }),
  badges: PropTypes.node,
  meta: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.elementType,
    label: PropTypes.node.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
  })),
  actions: PropTypes.node,
  edited: PropTypes.node,
  children: PropTypes.node,
};

EventHeader.defaultProps = {
  rootCrumb: { label: "Calendar", href: "/dashboard" },
  meta: [],
};

export default EventHeader;
